import { Card, Image, Text, Box, Flex, Avatar, NumberFormatter, ThemeIcon, ActionIcon, Stack, Menu, Tooltip } from '@mantine/core';
import NoImage from '../../../assets/img/images/no-images.png'
import { IconArrowNarrowRight, IconClockSearch, IconCopyPlus, IconDotsVertical, IconEye, IconEyeOff, IconFiles, IconPencil, IconStar, IconTrash } from '@tabler/icons-react';

const ProductCard = ({dataProduct, handleAction }) => {

  const handleClickMenu = (e, key) => {
    e.stopPropagation() // ⛔ prevent parent click
    handleAction(dataProduct, key)
  }
  const handleClick = (e) => {
    e.stopPropagation() // ⛔ prevent parent click
  }

  // overlay menu action icon and status icon
  const overlayMenuAction = () => {
    return (
      <Menu withArrow trigger="hover" shadow="md" width={220} style={{ position: 'absolute', top: '0', right: '0', margin: '8px' }}>
        <Menu.Target>

          <ActionIcon variant="default" radius="xl" aria-label="Settings" style={{ position: 'absolute', top: '0', right: '0', margin: '8px' }} onClick={handleClick}>
            <IconDotsVertical style={{ width: '70%', height: '70%' }} stroke={1.5} />
          </ActionIcon>
        </Menu.Target>

        <Menu.Dropdown>
          <Menu.Label>Application</Menu.Label>
          <Menu.Item leftSection={<IconPencil size={14} />} onClick={(e) => handleClickMenu(e, 'edit')}>
            Edit
          </Menu.Item>
          <Menu.Item leftSection={<IconFiles size={14} />} onClick={(e) => handleClickMenu(e, 'clone')}>
            Clone
          </Menu.Item>
          <Menu.Item leftSection={<IconCopyPlus size={14} />} onClick={(e) => handleClickMenu(e, 'addSubProduct')}>
            Add Sub-Product
          </Menu.Item>
          <Menu.Item
            leftSection={<IconArrowNarrowRight size={14} />}
            rightSection={
              <Text size="xs" c="dimmed">
                ({dataProduct.subProductCount})
              </Text>
            }
            onClick={(e) => handleClickMenu(e, 'seeSubProduct')}
          >
            View Sub-Product
          </Menu.Item>

          <Menu.Divider />

          <Menu.Label>Danger zone</Menu.Label>
          <Menu.Item
            color="red"
            leftSection={<IconTrash size={14} />}
            onClick={(e) => handleClickMenu(e, 'delete')}
          >
            Delete Product
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    )
  }
  
  const overlayStatusIcon = () => {
    const { visibility, notShowInCatalog, status, subProductCount } = dataProduct;

    // logic to show status icon
    const isHiddenFromCatalog = notShowInCatalog && visibility
    const isHiddenFromApp = !visibility
    const isLive = !notShowInCatalog && visibility
    const isMasterProduct = Boolean(subProductCount)

    return (
      <Stack gap="xs" style={{ position: 'absolute', top: 0, left: 0, margin: 8 }}>
        {isHiddenFromCatalog && (
          <Tooltip label="The product is not displayed in the catalog; it only appears on the supplier page.">
            <ThemeIcon variant="default" radius="xl">
              <IconEyeOff style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ThemeIcon>
          </Tooltip>
        )}

        {isHiddenFromApp && (
          <Tooltip
            label={`The product is not displayed in the application because it is still in ${status} status.`}
          >
            <ThemeIcon variant="default" radius="xl">
              <IconClockSearch style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ThemeIcon>
          </Tooltip>
        )}

        {isLive && (
          <Tooltip label="This product is live and displayed on all pages.">
            <ThemeIcon variant="default" radius="xl">
              <IconEye style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ThemeIcon>
          </Tooltip>
        )}

        {isMasterProduct && (
          <Tooltip label="This product is a Master Product; because this product has several sub-product data">
            <ThemeIcon variant="default" radius="xl">
              <IconStar style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ThemeIcon>
          </Tooltip>
        )}
      </Stack>
    )
  }

  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder style={{ cursor: 'pointer' }}>
      <Card.Section>
        <Box pos='relative'>
          <Image
            src={dataProduct.image || NoImage}
            height={260}
            alt="Product"
          />
          {overlayMenuAction()}
          {overlayStatusIcon()}
        </Box>
      </Card.Section>

      <Box mt="xs">
        <Text size="xs" lineClamp={2} h={32}>{dataProduct.title}</Text>
      </Box>
      <Box mt="xs">
        <Text fw={500}><NumberFormatter prefix={`${dataProduct.originalCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={dataProduct.regularPrice} /></Text>
      </Box>

      <Text size="xs" c="dimmed">
        Sale Price: <NumberFormatter prefix={`${dataProduct.originalCurrency} `} thousandSeparator="," decimalSeparator="." decimalScale={2} fixedDecimalScale={true} value={dataProduct.salePrice} />
      </Text>
      <Text size="xs" c="dimmed">
        Brands: {dataProduct.brands}
      </Text>
      <Text size="xs" c="dimmed">
        Warehouse: {dataProduct.warehouse}
      </Text>
      <Text size="xs" c="dimmed">
        Weight: {dataProduct.weight}{dataProduct.weightUnit}
      </Text>
      <Text size="xs" c="dimmed" lineClamp={1}>
        Created by User {dataProduct.creator}
      </Text>


      <Flex gap='xs' align='center' mt={10}>
        <Avatar variant='filled' name={dataProduct.supplier} radius="xl" size="xs" color='red' />
        <Box>
          <Text size="xs" lineClamp={1}>{dataProduct.supplier}</Text>
        </Box>
      </Flex>

      {/* <Button color="blue" fullWidth mt="md" radius="md">
        Book classic tour now
      </Button> */}
    </Card>
  );
}

export default ProductCard